import React, { useCallback, useEffect, useState } from "react";

import { ReportProps } from "../../../../types/types";
import "./ReportTransformation.css";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import { MenuItem, TextField } from "@mui/material";
import { commonGet } from "../../../../services/reportService";
import { useAuth } from "../../../../providers/AuthProvider";

export function ReportTransformation(props: ReportProps) {
  const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
  interface Option {
    readonly label: string;
    readonly value: string;
  }
  const [options, setOptions] = useState<Option[]>([]);
  const [showTransformation, setShowTransformation] = useState<boolean>(false);
  const [transformerValue, setTransformerValue] = useState<string>("");

  const createOption = (label: any): any => {
    return {
      label: label,
      value: label,
    };
  };

  const getTransformers =useCallback( async (): Promise<void> => {
    let url = "/v1/registry/meta/TransformerInfo/id";
    let response = await commonGet(url, authContext);
    if (response != null) {
      const optionValues = response.features.map((label: any) => {
        return createOption(label);
      });
      setOptions(optionValues);
    }
  },[]);

  useEffect(() => {
    getTransformers();
  }, [getTransformers]);

  


  const handleChangeTransformerInput = (event: any) => {
    setShowTransformation(event.target.value === "yes");
  };

  const selectTransformer = (event: {
    target: { value: React.SetStateAction<string> };
  }) => {
    setTransformerValue(event.target.value);
    props.setReportState((currentState) => ({
      ...currentState,
      reportInfo: {
        ...currentState.reportInfo,
        transformer: event.target.value as string,
      },
      validationErrors: currentState.validationErrors.filter(
        (er) => er.property !== "report_transformer"
      ),
    }));
  };
  const existingTransformationElement = (
    <div>
      <TextField
        id="transformer"
        select
        label="Transformer:"
        value={transformerValue}
        onChange={selectTransformer}
        sx={{ m: 1, width: "75%" }}
        SelectProps={{
          readOnly: props.reportInfo.viewEditStatus === "VIEW" ? true : false,
          native: false,
        }}
        placeholder="Select Transformer"
        helperText="Select appropriate Transformer from existing tranfromers"
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </div>
  );


  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div className="full-width">
          {/* <h3 className='transformation-heading'> Do You want Transformation ? </h3> */}
          <FormControl>
            <FormLabel id="demo-row-radio-buttons-group-label">
              Do You want Transformation ?
            </FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              className="radiogp"
              // onChange={()=> setShowTransformation(showTransformation)}
              onChange={handleChangeTransformerInput}
              id="transformation"
              defaultValue="no"
            >
              <FormControlLabel
                value="yes"
                control={<Radio />}
                label="YES"
                disabled={
                  props.reportInfo.viewEditStatus === "VIEW" ? true : false
                }
              />
              <FormControlLabel
                value="no"
                control={<Radio />}
                label="NO"
                disabled={
                  props.reportInfo.viewEditStatus === "VIEW" ? true : false
                }
              />
            </RadioGroup>
          </FormControl>
          {/* {transformationContent()} */}
          {showTransformation && existingTransformationElement}
        </div>
      </div>
    </div>
  );
}
